import script from "./PortfolioCompetencies.vue?vue&type=script&setup=true&lang=js"
export * from "./PortfolioCompetencies.vue?vue&type=script&setup=true&lang=js"

import "./PortfolioCompetencies.vue?vue&type=style&index=0&id=3e25d068&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e25d068"]])

export default __exports__